var render = function render(){var _vm=this,_c=_vm._self._c;return (this.isArray)?_c('div',_vm._l((_vm.value),function(item){return _c('div',{key:item},[_c('form-result-value-display',{attrs:{"value":item}})],1)}),0):_c('form-result-value-display',{attrs:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }